import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Dashboard from "@/pages/dashboard/page";
import Expenses from "@/pages/expenses/page";
import NewExpense from "@/pages/expense-new/page";
import ExpenseDetail from "@/pages/expense-detail/page";
import Receipts from "@/pages/receipts/page";
import Statistics from "@/pages/statistics/page";
import Categories from "@/pages/categories/page";
import Settings from "@/pages/settings/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/gastos",
    element: <Expenses />,
  },
  {
    path: "/gastos/nuevo",
    element: <NewExpense />,
  },
  {
    path: "/gastos/:id",
    element: <ExpenseDetail />,
  },
  {
    path: "/recibos",
    element: <Receipts />,
  },
  {
    path: "/estadisticas",
    element: <Statistics />,
  },
  {
    path: "/categorias",
    element: <Categories />,
  },
  {
    path: "/configuracion",
    element: <Settings />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;